import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './icons/GreenCheck-Icon.svg'


_pushScopeId("data-v-5a439527")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "includes-text" }, "What's included?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  opacity: "0.5",
  cx: "9",
  cy: "9",
  r: "9",
  fill: "#C4C4C4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8L9 11L6 8",
  stroke: "#6C6C6C",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "mt-3 row" }
const _hoisted_10 = {
  key: 0,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Protect 1 phone + 25 items ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Unlimited Phones ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Unlimited Non-Phone Electronics ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "p-1 col-12 col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "pe-2",
    height: "11",
    src: _imports_0,
    alt: "✓"
  }),
  /*#__PURE__*/_createTextVNode(" Accidental Damage ")
], -1)
const _hoisted_23 = {
  key: 3,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Phone parts and battery failure ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 4,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Theft protection ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 5,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Mechanical Breakdown ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 6,
  class: "p-1 col-12 col-xl-6"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Up to $2,000 per claim ")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "p-1 col-12 col-xl-6" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Unlimited Claims ")
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 7,
  class: "mt-3 col-12"
}
const _hoisted_44 = {
  key: 8,
  class: "mt-3 col-12"
}
const _hoisted_45 = { class: "\n          d-flex\n          align-items-center\n          justify-content-between\n          ps-1\n          price-container\n        " }
const _hoisted_46 = {
  key: 0,
  class: "cera-med nowrap mb-0"
}
const _hoisted_47 = {
  key: 1,
  class: "cera-med nowrap mb-0"
}
const _hoisted_48 = {
  key: 2,
  class: "cera-med nowrap mb-0"
}
const _hoisted_49 = {
  key: 3,
  class: "cera-med nowrap mb-0"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, "per month", -1)
const _hoisted_51 = { class: "d-flex align-items-center pe-1 deductible" }
const _hoisted_52 = {
  key: 0,
  class: "pe-1"
}
const _hoisted_53 = {
  key: 1,
  class: "pe-1"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", null, "deductibles", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInclude && _ctx.toggleInclude(...args))),
      class: _normalizeClass(["\n      d-flex\n      includes-container\n      mt-2\n      py-2\n      pe-2\n      ps-4\n      justify-content-between\n      align-items-center\n    ", { 'includes-container-open': _ctx.includeOpen || _ctx.open, pointer: !_ctx.open }])
    }, [
      _hoisted_1,
      (!_ctx.open)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            class: _normalizeClass(["chevron", { 'chevron-rotate': _ctx.includeOpen }]),
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_4, 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{
      'plan-details-container-transition': _ctx.includeOpen || _ctx.open,
      'z-9': _ctx.includeOpen || _ctx.open,
    }, "\n      d-flex\n      flex-column\n      align-items-flex-start\n      justify-content-flex-start\n      plan-details-container\n      px-4\n    "])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["plan-details-container-text inter", { 'plan-details-container-text-transition': _ctx.includeOpen || _ctx.open }])
      }, [
        (_ctx.isAKKOPlan)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Protect 1 phone + 25 items per plan. Personal and home electronics and more!"))
          : _createCommentVNode("", true),
        (_ctx.isPhonePlan)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Protect 1 phone per plan against damages, breakdowns, and theft"))
          : _createCommentVNode("", true),
        (_ctx.isHomeRegularPlan)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Protect unlimited home electronics"))
          : _createCommentVNode("", true),
        (_ctx.isHomePlusPlan)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Protect unlimited phones + unlimited personal & home electronics"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isAKKOPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.isHomePlusPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.isHomePlusPlan || _ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
            : _createCommentVNode("", true),
          _hoisted_22,
          (_ctx.isAKKOPlan || _ctx.isPhonePlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
            : _createCommentVNode("", true),
          (_ctx.isAKKOPlan || _ctx.isPhonePlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
            : _createCommentVNode("", true),
          (_ctx.isHomePlusPlan || _ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
            : _createCommentVNode("", true),
          (_ctx.isAKKOPlan || _ctx.isHomePlusPlan || _ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _hoisted_41,
            (_ctx.isHomePlusPlan || _ctx.isHomeRegularPlan)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "*"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isHomePlusPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " *Annual limit of $6000 "))
            : _createCommentVNode("", true),
          (_ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " *Annual limit of $6000 / sub-limit of $3,000 for claims on phones "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("hr", {
          class: _normalizeClass(["line", { 'line-transition': _ctx.includeOpen || _ctx.open }])
        }, null, 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["\n        d-flex\n        flex-row\n        plan-details-container-text\n        justify-content-between\n        mb-3\n      ", { 'plan-details-container-text-transition': _ctx.includeOpen || _ctx.open }])
      }, [
        _createElementVNode("div", _hoisted_45, [
          (_ctx.isAKKOPlan)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_46, "$15"))
            : _createCommentVNode("", true),
          (_ctx.isPhonePlan)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_47, "$5-$12"))
            : _createCommentVNode("", true),
          (_ctx.isHomePlusPlan)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_48, " $" + _toDisplayString(_ctx.homePlusCoverage
              ? _ctx.homePlusCoverage[_ctx.PlanIntervals.MONTHLY].price
              : '-'), 1))
            : _createCommentVNode("", true),
          (_ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_49, " $" + _toDisplayString(_ctx.homeRegularCoverage
              ? _ctx.homeRegularCoverage[_ctx.PlanIntervals.MONTHLY].price
              : '-'), 1))
            : _createCommentVNode("", true),
          _hoisted_50
        ]),
        _createElementVNode("div", _hoisted_51, [
          (!_ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, "$29-$99"))
            : _createCommentVNode("", true),
          (_ctx.isHomeRegularPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, "$99"))
            : _createCommentVNode("", true),
          _hoisted_54
        ])
      ], 2)
    ], 2)
  ], 64))
}